/* @flow */
import cx from 'classnames';
import * as React from 'react';
import MessageReaction from 'chat_v2/components/MessageReaction';
import ReactionButton from 'chat_v2/components/ReactionButton';
import ReactionPickerTrigger from 'chat_v2/components/ReactionPickerTrigger';

import './styles/ReactionDisplay.scss';

type Props = {
  sentBySelf?: boolean,
  addReactionToSummary: Function,
  disableReactionToggle?: boolean,
  removeReactionFromSummary: Function,
  reactionSummary: ?ReactionSummaryGQL,
};

class ReactionDisplay extends React.Component<Props> {
  renderReaction = (reaction: ReactionGQL) => {
    return (
      <MessageReaction
        key={reaction.name}
        reaction={reaction}
        disableReactionToggle={!!this.props.disableReactionToggle}
        addReactionToSummary={this.props.addReactionToSummary}
        removeReactionFromSummary={this.props.removeReactionFromSummary}
      />
    );
  };

  render() {
    const { disableReactionToggle, reactionSummary, sentBySelf } = this.props;
    const reactions = reactionSummary ? reactionSummary.reactions : null;

    if (!reactions || !reactions.length) {
      return null;
    }

    return (
      <div
        className={cx('ReactionDisplay', {
          'ReactionDisplay-self': sentBySelf,
          'ReactionDisplay-other': !sentBySelf,
        })}>
        {reactions.map(this.renderReaction)}
        {!disableReactionToggle && (
          <ReactionPickerTrigger
            className="ReactionDisplay-addButton"
            alignment={sentBySelf ? 'right' : 'left'}
            addReactionToSummary={this.props.addReactionToSummary}
            removeReactionFromSummary={this.props.removeReactionFromSummary}>
            <ReactionButton includeBorder />
          </ReactionPickerTrigger>
        )}
      </div>
    );
  }
}

export default ReactionDisplay;
